var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "marker-pin-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.5 6.5C3.5 5.30653 3.97411 4.16193 4.81802 3.31802C5.66193 2.47411 6.80653 2 8 2C9.19347 2 10.3381 2.47411 11.182 3.31802C12.0259 4.16193 12.5 5.30653 12.5 6.5C12.5 9.5 8 14 8 14C8 14 3.5 9.5 3.5 6.5ZM6.125 6.5C6.125 6.99728 6.32254 7.47419 6.67417 7.82583C7.02581 8.17746 7.50272 8.375 8 8.375C8.49728 8.375 8.97419 8.17746 9.32583 7.82583C9.67746 7.47419 9.875 6.99728 9.875 6.5C9.875 6.00272 9.67746 5.52581 9.32583 5.17417C8.97419 4.82254 8.49728 4.625 8 4.625C7.50272 4.625 7.02581 4.82254 6.67417 5.17417C6.32254 5.52581 6.125 6.00272 6.125 6.5Z",
    fill: "#ffffff50"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerPin);
export default __webpack_public_path__ + "static/media/marker_pin.7113e32279f3cc3c88fad03a0943befe.svg";
export { ForwardRef as ReactComponent };